import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Cookie, X } from "lucide-react";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = (type) => {
    localStorage.setItem("cookie_consent", type);
    localStorage.setItem("cookie_consent_date", new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-fade-up">
      <div className="bg-white border-t border-[#E5DDD3] shadow-2xl shadow-black/10">
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-5">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="flex items-start gap-3 flex-1">
              <Cookie size={20} className="text-[#B8945A] flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-sans text-sm text-[#1C2B3A] leading-relaxed">
                  This website uses cookies to enhance your browsing experience. We use essential
                  cookies for site functionality and optional cookies for analytics.
                  By clicking \"Accept All,\" you consent to all cookies in accordance with our{" "}
                  <Link to="/privacy" className="text-[#B8945A] underline hover:text-[#96783E] transition-colors">Privacy Policy</Link>,
                  the EU General Data Protection Regulation (GDPR), and India's Digital Personal Data
                  Protection Act, 2023.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0 w-full md:w-auto">
              <Button
                variant="outline"
                onClick={() => handleAccept("essential")}
                className="border-[#E5DDD3] text-[#4A4A4A] hover:bg-[#FAF8F4] font-sans text-xs tracking-wider h-9 px-4 flex-1 md:flex-none"
              >
                Essential Only
              </Button>
              <Button
                onClick={() => handleAccept("all")}
                className="bg-[#1C2B3A] hover:bg-[#2A3F54] text-white font-sans text-xs tracking-wider h-9 px-5 flex-1 md:flex-none"
              >
                Accept All
              </Button>
              <button
                onClick={() => setVisible(false)}
                className="text-[#7A7A7A] hover:text-[#1C2B3A] transition-colors p-1 hidden md:block"
              >
                <X size={16} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;